import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScrollVertical } from 'elements/functional/ScrollVertical';
import { motion } from 'framer-motion';
import { EColors, EGrads, EHovers } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    content: JSX.Element;
    background?: string;
    footer: JSX.Element;
    onClose: () => void;
}

export const SidebarModalWrapperPc = (props: Props): JSX.Element => {
    const animation = {
        initial: { right: '-470px' },
        animate: { right: '0px' },
        transition: {
            delay: 0.1,
            right: { duration: 0.2 },
            default: { ease: 'linear' }
        }
    };

    return (
        <S_SidebarModalWrapperPc
            $background={props.background}
            className={props.className}
            {...animation}
        >
            <S_CloseWrapper
                {...animation}
                animate={{
                    right: '30px'
                }}
                onClick={() => {
                    props.onClose();
                }}
            >
                <S_Close icon={['fal', 'xmark']} />
            </S_CloseWrapper>
            <S_Scroll light={true}>{props.content}</S_Scroll>
            {props.footer}
        </S_SidebarModalWrapperPc>
    );
};

const S_SidebarModalWrapperPc = styled(motion.div)<{ $background: string }>`
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 470px;
    border-left: 1px solid ${EColors.BLACK3};
    background: ${(props) => props.$background || '#f1f1f1'};
    display: flex;
    flex-direction: column;
    z-index: 2000000;
`;

const S_Scroll = styled(ScrollVertical)`
    display: flex;
    flex-direction: column;
`;

const S_CloseWrapper = styled(motion.div)`
    top: 10px;
    right: 15px;
    position: fixed;
    z-index: 2000001;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: ${EColors.DARK};
    background: ${EGrads.ACC1_GRAD};
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
        box-shadow: ${EHovers.LIGHT2}, 0px 10px 30px rgba(0, 0, 0, 0.3);
    }
`;

const S_Close = styled(FontAwesomeIcon)`
    font-size: 18px;
    padding: 5px;
    display: flex;
`;
